











































































import Card from '@/components/UI/Card.vue';
import OmnichannelIndividualParamsModal
  from '@/pages/omnichannel-strategy/tabs/products/OmnichannelIndividualParamsModal.vue';
import OmnichannelStrategyApi from '@/pages/omnichannel-strategy/api/OmnichannelStrategyApi';
import {IOmnichannelStrategyFilters, IOmnichannelStrategyTableDto,} from '@/pages/omnichannel-strategy/types/data';
import {
  IProductListFilter,
  IProductListBaseParams, IProductListItem
} from '@/pages/omnichannel-strategy/types/product-list';
import {OmnichannelStrategy} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {FormatNumber} from '@/numberFormatter';
import { Formatter } from '@/helpers/formatters';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import UploadWithErrorsBlock from '@/components/UI/UploadWithErrorsBlock.vue';

@Component({
  components: {
    UploadWithErrorsBlock,
    Card,
    OmnichannelIndividualParamsModal,
  },
})
export default class OmnichannelProductsList extends Mixins(LocalData, Http) {
  @Prop({type: Array, default: () => []}) readonly selectedStrategies!: IOmnichannelStrategyTableDto[];
  @Prop({type: Object, required: true}) readonly filters!: IOmnichannelStrategyFilters;

  private api: OmnichannelStrategyApi = new OmnichannelStrategyApi({parent: this});
  private skuFilter: string = '';
  private skuList: IProductListItem[] = [];
  private isPageTableLoading: boolean = false;
  private isDownloadLoading: boolean = false;
  private errorsAmount: number = 0;
  private tableFilterSignature: string = '';
  private selectedStrategyFilters: string[] = [];
  private selectedGroupFilters: number[] = [];
  private selectedCategoryFilters: number[] = [];
  private selectedSubcategoryFilters: number[] = [];
  private selectedStoreFormatFilters: number[] = [];
  private selectedStoreRegionFilters: number[] = [];
  private selectedStoreClusterFilters: number[] = [];
  private selectedKht1Filters: string[] = [];
  private groupFilterOptions: Array<{ text: string; value: string }> = [];
  private categoryFilterOptions: Array<{ text: string; value: string }> = [];
  private subcategoryFilterOptions: Array<{ text: string; value: string }> = [];
  private storeFormatFilterOptions: Array<{ text: string; value: string }> = [];
  private storeRegionFilterOptions: Array<{ text: string; value: string }> = [];
  private storeClusterFilterOptions: Array<{ text: string; value: string }> = [];
  private kht1FilterOptions: Array<{ text: string; value: string }> = [];
  private needLoadTableFilterOptions: boolean = true;
  private lastTableFilterOptionsQueryKey: string | null = null;
  pagination = {
    current: 1,
    pageSize: 10,
    total: 0
  }

  private numberFormatter = (v: any): string => FormatNumber.format(v);

  private get hasTradingId(): boolean {
    const id = this.tradingId;
    return id != null && id > 0;
  }

  private get tradingId(): number | null {
    const selectedStrategy = this.selectedStrategies.find(
      (strategy) => strategy.tradingNetId != null && strategy.tradingNetId > 0,
    );
    const selectedStrategyTradingId = selectedStrategy ? selectedStrategy.tradingNetId : null;
    if (selectedStrategyTradingId != null && selectedStrategyTradingId > 0) {
      return selectedStrategyTradingId;
    }

    return this.filters && this.filters.market && this.filters.market.id > 0
      ? this.filters.market.id
      : null;
  }

  private normalizeFilterValue(value: number | null | undefined): number | null {
    return value != null && value > 0 ? value : null;
  }

  private formatYesNo(value: any): string {
    return value != null ? (value ? this.$tc('shared.actions.yes') : this.$tc('shared.actions.no')) : '';
  }

  private formatFixedGapType(value: any): string {
    if (value == null) return '';
    const key = `omnichannelStrategy.fixedGapTypes.${value}`;
    const translated = this.$tc(key);
    return translated !== key ? translated : String(value);
  }

  private formatStrategy(value: any): string {
    if (value == null) return '';
    const key = `omnichannelStrategy.strategies.${value}`;
    const translated = this.$tc(key);
    return translated !== key ? translated : String(value);
  }

  private formatDate(value: any): string {
    return value ? new Date(value).toLocaleDateString() : '';
  }

  private toTagFilterOptions(options: Array<{ id: number; name: string }>): Array<{ text: string; value: string }> {
    return options.map((option) => ({
      text: option.name,
      value: String(option.id),
    }));
  }

  private toTextFilterOptions(values: string[]): Array<{ text: string; value: string }> {
    return values.map((value) => ({
      text: value,
      value,
    }));
  }

  private get strategyFilterOptions(): Array<{ text: string; value: string }> {
    return [
      { text: this.formatStrategy(OmnichannelStrategy.PRICE_EQUALITY), value: OmnichannelStrategy.PRICE_EQUALITY },
      { text: this.formatStrategy(OmnichannelStrategy.FIXED_DIFFERENCE), value: OmnichannelStrategy.FIXED_DIFFERENCE },
      { text: this.formatStrategy(OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML), value: OmnichannelStrategy.OPTIMAL_DIFFERENCE_ML },
    ];
  }

  private toStringArray(value: any): string[] {
    return Array.isArray(value) ? value.map((item) => String(item)) : [];
  }

  private toNumberArray(value: any): number[] {
    return this.toStringArray(value)
      .map((item) => Number(item))
      .filter((item) => !Number.isNaN(item) && item > 0);
  }

  private get tableColumns(): any[] {
    return [
    { dataIndex: 'internalCode', title: this.$tc('omnichannelStrategy.products.columns.internalCode'), width: 100 },
    { dataIndex: 'skuName', title: this.$tc('omnichannelStrategy.products.columns.skuName'), width: 170, ellipsis: true },
    {
      dataIndex: 'strategy',
      title: this.$tc('omnichannelStrategy.products.columns.strategy'),
      width: 120,
      customRender: (value: any) => (value ? this.formatStrategy(value) : '-'),
      ellipsis: true,
      key: 'strategy',
      filters: this.strategyFilterOptions,
      filteredValue: this.selectedStrategyFilters,
    },
    {
      dataIndex: 'fixedGapType',
      title: this.$tc('omnichannelStrategy.products.columns.gap'),
      width: 90,
      customRender: (value: any) => (value ? this.formatFixedGapType(value) : '-'),
      scopedSlots: { filterDropdown: 'fixedGapType', },
    },
    {
      dataIndex: 'gap',
      title: this.$tc('omnichannelStrategy.products.columns.gapPercent'),
      width: 90,
      customRender: (value: any) => (value != null ? String(value) : '-'),
      scopedSlots: { filterDropdown: 'gap',},
    },
    {
      dataIndex: 'considerCompetitivePricing',
      title: this.$tc('omnichannelStrategy.products.columns.considerCompetitivePricing'),
      width: 180,
      customRender: (value: any) => this.formatYesNo(value),
      scopedSlots: { filterDropdown: 'considerCompetitivePricingFilter' },
    },
    {
      dataIndex: 'minProfitabilityLimit',
      title: this.$tc('omnichannelStrategy.products.columns.minProfitabilityLimit'),
      width: 220,
      customRender: (value: any) => value != null ? this.formatYesNo(value) : '-',
      scopedSlots: { filterDropdown: 'minProfitabilityLimitFilter'},
    },
    {
      dataIndex: 'remains',
      title: this.$tc('omnichannelStrategy.products.columns.remains'),
      width: 70,
      customRender: (value: any) => (value !== null && value !== undefined) ? String(value) : '-',
    },
    {
      dataIndex: 'expiration',
      title: this.$tc('omnichannelStrategy.products.columns.expiration'),
      width: 100,
      scopedSlots: { customRender: 'expirationField' },
    },
    {
      dataIndex: 'group.name',
      title: this.$tc('omnichannelStrategy.products.columns.productGroup'),
      width: 150,
      ellipsis: true,
      key: 'group',
      filters: this.groupFilterOptions,
      filteredValue: this.selectedGroupFilters.map(String),
    },
    {
      dataIndex: 'category.name',
      title: this.$tc('omnichannelStrategy.products.columns.productCategory'),
      width: 150,
      ellipsis: true,
      key: 'category',
      filters: this.categoryFilterOptions,
      filteredValue: this.selectedCategoryFilters.map(String),
    },
    {
      dataIndex: 'subcategory.name',
      title: this.$tc('omnichannelStrategy.products.columns.productSubcategory'),
      width: 170,
      ellipsis: true,
      key: 'subcategory',
      filters: this.subcategoryFilterOptions,
      filteredValue: this.selectedSubcategoryFilters.map(String),
    },
    {
      dataIndex: 'storeFormat.name',
      title: this.$tc('omnichannelStrategy.products.columns.format'),
      width: 120,
      ellipsis: true,
      key: 'storeFormat',
      filters: this.storeFormatFilterOptions,
      filteredValue: this.selectedStoreFormatFilters.map(String),
    },
    {
      dataIndex: 'storeRegion.name',
      title: this.$tc('omnichannelStrategy.products.columns.region'),
      width: 120,
      ellipsis: true,
      key: 'storeRegion',
      filters: this.storeRegionFilterOptions,
      filteredValue: this.selectedStoreRegionFilters.map(String),
    },
    {
      dataIndex: 'storeCluster.name',
      title: this.$tc('omnichannelStrategy.products.columns.cluster'),
      width: 120,
      ellipsis: true,
      key: 'storeCluster',
      filters: this.storeClusterFilterOptions,
      filteredValue: this.selectedStoreClusterFilters.map(String),
    },
    { dataIndex: 'productSegmentName', title: this.$tc('omnichannelStrategy.products.columns.productSegments'), width: 120, ellipsis: true },
    {
      dataIndex: 'keyCharacteristicOfTheProductIsOne',
      title: this.$tc('omnichannelStrategy.products.columns.kht1'),
      width: 120,
      ellipsis: true,
      key: 'kht1',
      filters: this.kht1FilterOptions,
      filteredValue: this.selectedKht1Filters,
    },
    { dataIndex: 'keyCharacteristicOfTheProductIsTwo', title: this.$tc('omnichannelStrategy.products.columns.kht2'), width: 120, ellipsis: true },
    { dataIndex: 'recipeAttribute', title: this.$tc('omnichannelStrategy.products.columns.prc'), width: 120, ellipsis: true },
    { dataIndex: 'treatmentAttribute', title: this.$tc('omnichannelStrategy.products.columns.pkl'), width: 120, ellipsis: true },
    {
      dataIndex: 'kvi',
      title: 'KVI',
      width: 80,
      customRender: (value: any) => this.formatYesNo(value),
    },
    { dataIndex: 'tagsKvi', title: this.$tc('omnichannelStrategy.products.columns.kviTags'), width: 100 },
    { dataIndex: 'ctm', title: this.$tc('omnichannelStrategy.products.columns.ctm'), width: 70, ellipsis: true },
    { dataIndex: 'productRange', title: this.$tc('omnichannelStrategy.products.columns.productRange'), width: 130, ellipsis: true },
    {
      dataIndex: 'lastPrice',
      title: this.$tc('omnichannelStrategy.products.columns.lastPrice'),
      width: 130,
      customRender: (value: any) => (value ? this.numberFormatter(value) : '-'),
    },
    {
      dataIndex: 'priceSegment',
      title: this.$tc('omnichannelStrategy.products.columns.priceSegment'),
      width: 150,
      ellipsis: true,
      customRender: (value: any, row: any) =>
        [row.priceSegmentMin, row.priceSegmentMax].some((v) => v != null)
          ? `${row.priceSegmentMin != null ? this.numberFormatter(row.priceSegmentMin) : ''} - ${row.priceSegmentMax != null ? this.numberFormatter(row.priceSegmentMax) : ''}`
          : '-',
    },
    {
      dataIndex: 'lastPriceMarginPc',
      title: this.$tc('omnichannelStrategy.products.columns.lastPriceMargin'),
      width: 150,
      ellipsis: true,
      customRender: (value: any) => this.numberFormatter(value),
    },
    {
      dataIndex: 'actualProfitability',
      title: this.$tc('omnichannelStrategy.products.columns.actualProfitability'),
      width: 120,
      ellipsis: true,
      customRender: (value: any) => this.numberFormatter(value),
    },
    {
      dataIndex: 'purchasePriceAvgM',
      title: this.$tc('omnichannelStrategy.products.columns.avgPurchasePrice'),
      width: 100,
      ellipsis: true,
      customRender: (value: any) => this.numberFormatter(value),
    },
    { dataIndex: 'coefficentList', title: this.$tc('omnichannelStrategy.products.columns.priceOptStrategy'), width: 200, ellipsis: true },
    { dataIndex: 'priceIncreaseLimit', title: this.$tc('omnichannelStrategy.products.columns.priceIncreaseLimit'), width: 150 },
    { dataIndex: 'periodPriceIncreaseLimit', title: this.$tc('omnichannelStrategy.products.columns.periodPriceIncreaseLimit'), width: 160 },
    { dataIndex: 'period', title: this.$tc('omnichannelStrategy.products.columns.period'), width: 80 },
    { dataIndex: 'marginalProfit', title: this.$tc('omnichannelStrategy.products.columns.minProfitabilitySku'), width: 150 },
    { dataIndex: 'maxMarginalProfit', title: this.$tc('omnichannelStrategy.products.columns.maxProfitabilitySku'), width: 150 },
    { dataIndex: 'kviStrategy', title: this.$tc('omnichannelStrategy.products.columns.kviStrategy'), width: 130, ellipsis: true },
    { dataIndex: 'percentageOfCompetitorsPrice', title: this.$tc('omnichannelStrategy.products.columns.correction'), width: 100 },
    {
      dataIndex: 'productVolume',
      title: this.$tc('omnichannelStrategy.products.columns.vgh'),
      width: 40,
      customRender: (value: any) => this.numberFormatter(value),
    },
    { dataIndex: 'measurementUnit', title: this.$tc('omnichannelStrategy.products.columns.measurementUnit'), width: 35 },
    { dataIndex: 'productVerticalLine', title: this.$tc('omnichannelStrategy.products.columns.vlName'), width: 75, ellipsis: true },
    {
      dataIndex: 'isVerticalLineBase',
      title: this.$tc('omnichannelStrategy.products.columns.baseProduct'),
      width: 60,
      customRender: (value: any) => this.formatYesNo(value),
    },
    { dataIndex: 'vlStrategyStr', title: this.$tc('omnichannelStrategy.products.columns.vlStrategy'), width: 75 },
    {
      dataIndex: 'vlGapPc',
      title: this.$tc('omnichannelStrategy.products.columns.vlGapPercent'),
      width: 140,
      customRender: (_value: any, record: any) => Formatter.vlGap(record.vlGapPc, record.vlGapType),
    },
    ];
  }

  private onSearch() {
    this.pagination.current = 1;
    this.fetchSkuList();
  }

  private onTableChange(pagination: any, filters: any) {
    const signature = JSON.stringify(filters || {});
    const filtersChanged = signature !== this.tableFilterSignature;
    this.tableFilterSignature = signature;
    this.selectedStrategyFilters = this.toStringArray(filters && filters.strategy);
    this.selectedGroupFilters = this.toNumberArray(filters && filters.group);
    this.selectedCategoryFilters = this.toNumberArray(filters && filters.category);
    this.selectedSubcategoryFilters = this.toNumberArray(filters && filters.subcategory);
    this.selectedStoreFormatFilters = this.toNumberArray(filters && filters.storeFormat);
    this.selectedStoreRegionFilters = this.toNumberArray(filters && filters.storeRegion);
    this.selectedStoreClusterFilters = this.toNumberArray(filters && filters.storeCluster);
    this.selectedKht1Filters = this.toStringArray(filters && filters.kht1);
    this.pagination.current = filtersChanged ? 1 : pagination.current;
    this.pagination.pageSize = pagination.pageSize;
    this.fetchSkuList();
  }

  private clearFilterInUpperPanel() {
    this.skuFilter = '';
    this.pagination.current = 1;
    this.fetchSkuList();
  }

  private addTagFilterOption(
    options: Array<{ text: string; value: string }>,
    tag: { id: number; name: string } | null | undefined,
  ) {
    if (!tag || !tag.id) {
      return;
    }
    const value = String(tag.id);
    if (!options.some((option) => option.value === value)) {
      options.push({ text: tag.name, value });
    }
  }

  private collectUniqueTagIds(
    tagSelector: (strategy: IOmnichannelStrategyTableDto) => { id: number } | null | undefined,
  ): number[] {
    const ids = this.selectedStrategies
      .map(tagSelector)
      .filter((tag): tag is { id: number } => tag != null && tag.id > 0)
      .map((tag) => tag.id);

    return Array.from(new Set(ids));
  }

  private buildTableFilterSignature(): string {
    return JSON.stringify({
      strategy: this.selectedStrategyFilters,
      group: this.selectedGroupFilters.map(String),
      category: this.selectedCategoryFilters.map(String),
      subcategory: this.selectedSubcategoryFilters.map(String),
      storeFormat: this.selectedStoreFormatFilters.map(String),
      storeRegion: this.selectedStoreRegionFilters.map(String),
      storeCluster: this.selectedStoreClusterFilters.map(String),
      kht1: this.selectedKht1Filters,
    });
  }

  private ensureStrategyTagsInFilterOptions() {
    this.selectedStrategies.forEach((strategy) => {
      this.addTagFilterOption(this.groupFilterOptions, strategy.groupOfProduct);
      this.addTagFilterOption(this.categoryFilterOptions, strategy.productCategory);
      this.addTagFilterOption(this.subcategoryFilterOptions, strategy.subcategory);
      this.addTagFilterOption(this.storeFormatFilterOptions, strategy.dependStoreParams && strategy.dependStoreParams.format);
      this.addTagFilterOption(this.storeRegionFilterOptions, strategy.dependStoreParams && strategy.dependStoreParams.region);
      this.addTagFilterOption(this.storeClusterFilterOptions, strategy.dependStoreParams && strategy.dependStoreParams.cluster);
    });
  }

  private syncTableFiltersFromPageFilters() {
    const groupId = this.normalizeFilterValue(this.filters.groupOfProduct);
    if (groupId != null) {
      this.selectedGroupFilters = [groupId];
    }
    const categoryId = this.normalizeFilterValue(this.filters.categoryOfProduct);
    if (categoryId != null) {
      this.selectedCategoryFilters = [categoryId];
    }
    const subcategoryId = this.normalizeFilterValue(this.filters.subcategory);
    if (subcategoryId != null) {
      this.selectedSubcategoryFilters = [subcategoryId];
    }
    const storeFormatId = this.normalizeFilterValue(this.filters.formatSelected);
    if (storeFormatId != null) {
      this.selectedStoreFormatFilters = [storeFormatId];
    }
    const storeRegionId = this.normalizeFilterValue(this.filters.regionSelected);
    if (storeRegionId != null) {
      this.selectedStoreRegionFilters = [storeRegionId];
    }
    const storeClusterId = this.normalizeFilterValue(this.filters.clusterSelected);
    if (storeClusterId != null) {
      this.selectedStoreClusterFilters = [storeClusterId];
    }
  }

  private resetTableColumnFilters() {
    this.selectedStrategyFilters = [];
    this.selectedGroupFilters = [];
    this.selectedCategoryFilters = [];
    this.selectedSubcategoryFilters = [];
    this.selectedStoreFormatFilters = [];
    this.selectedStoreRegionFilters = [];
    this.selectedStoreClusterFilters = [];
  }

  private syncTableFiltersFromStrategyContext() {
    if (!this.selectedStrategies.length) {
      this.resetTableColumnFilters();
      this.syncTableFiltersFromPageFilters();
      this.tableFilterSignature = this.buildTableFilterSignature();
      return;
    }

    this.selectedGroupFilters = this.collectUniqueTagIds((strategy) => strategy.groupOfProduct);
    this.selectedCategoryFilters = this.collectUniqueTagIds((strategy) => strategy.productCategory);
    this.selectedSubcategoryFilters = this.collectUniqueTagIds((strategy) => strategy.subcategory);
    this.selectedStoreFormatFilters = this.collectUniqueTagIds(
      (strategy) => strategy.dependStoreParams && strategy.dependStoreParams.format,
    );
    this.selectedStoreRegionFilters = this.collectUniqueTagIds(
      (strategy) => strategy.dependStoreParams && strategy.dependStoreParams.region,
    );
    this.selectedStoreClusterFilters = this.collectUniqueTagIds(
      (strategy) => strategy.dependStoreParams && strategy.dependStoreParams.cluster,
    );
    this.ensureStrategyTagsInFilterOptions();
    this.tableFilterSignature = this.buildTableFilterSignature();
  }

  private getGeneralViewBaseParams(): IProductListBaseParams {
    const tradingId = this.tradingId!;
    const groupOfProduct = this.normalizeFilterValue(this.filters.groupOfProduct);
    const category = this.normalizeFilterValue(this.filters.categoryOfProduct);
    const subcategory = this.normalizeFilterValue(this.filters.subcategory);
    const storeFormat = this.normalizeFilterValue(this.filters.formatSelected);
    const storeRegion = this.normalizeFilterValue(this.filters.regionSelected);
    const storeCluster = this.normalizeFilterValue(this.filters.clusterSelected);

    return {
      tradingId,
      groupOfProduct,
      groupsOfProduct: groupOfProduct != null ? [groupOfProduct] : null,
      category,
      categories: category != null ? [category] : null,
      subcategories: subcategory != null ? [subcategory] : null,
      storeFormat,
      storeRegionValues: storeRegion != null ? [storeRegion] : null,
      storeCluster,
      storeClusters: storeCluster != null ? [storeCluster] : null,
    };
  }

  private getStrategyContextBaseParams(): IProductListBaseParams {
    return {
      tradingId: this.tradingId!,
      groupOfProduct: null,
      groupsOfProduct: null,
      category: null,
      categories: null,
      subcategories: null,
      storeFormat: null,
      storeRegionValues: null,
      storeCluster: null,
      storeClusters: null,
    };
  }

  private get isGeneralProductListView(): boolean {
    return this.selectedStrategies.length === 0;
  }

  private buildProductListFilterParams(): IProductListFilter | null {
    if (this.tradingId == null) {
      return null;
    }

    const base = this.selectedStrategies.length
      ? this.getStrategyContextBaseParams()
      : this.getGeneralViewBaseParams();

    return {
      ...base,
      calculationDepth: 4,
      calculationDay: 28,
      seasonValues: [],
      buyerSegments: [],
      productSegments: null,
      skuFilter: this.skuFilter || '',
      discountPrise: false,
      promo: false,
      kvi: 2,
      kviCartIdFilter: -1,
      needCalculateSku: false,
      saleIdFilter: -1,
      onlyWithOmnichannelIndividualStrategy: this.isGeneralProductListView,
      omnichannelStrategies: this.selectedStrategyFilters,
      productListGroupIds: this.selectedGroupFilters,
      productListCategoryIds: this.selectedCategoryFilters,
      productListSubcategoryIds: this.selectedSubcategoryFilters,
      productListStoreFormatIds: this.selectedStoreFormatFilters,
      productListStoreRegionIds: this.selectedStoreRegionFilters,
      productListStoreClusterIds: this.selectedStoreClusterFilters,
      keyCharacteristicOfTheProductIsOne: this.selectedKht1Filters.length ? this.selectedKht1Filters : null,
    } as IProductListFilter;
  }

  private buildProductListFilterOptionsParams(): IProductListFilter | null {
    if (this.tradingId == null) {
      return null;
    }

    return {
      tradingId: this.tradingId,
      groupOfProduct: null,
      groupsOfProduct: null,
      category: null,
      categories: null,
      subcategories: null,
      storeFormat: null,
      storeRegionValues: null,
      storeCluster: null,
      calculationDepth: 4,
      calculationDay: 28,
      seasonValues: [],
      buyerSegments: [],
      productSegments: null,
      skuFilter: '',
      discountPrise: false,
      promo: false,
      kvi: 2,
      kviCartIdFilter: -1,
      needCalculateSku: false,
      saleIdFilter: -1,
      onlyWithOmnichannelIndividualStrategy: this.isGeneralProductListView,
      omnichannelStrategies: [],
      productListGroupIds: [],
      productListCategoryIds: [],
      productListSubcategoryIds: [],
      productListStoreFormatIds: [],
      productListStoreRegionIds: [],
      productListStoreClusterIds: [],
      keyCharacteristicOfTheProductIsOne: null,
    } as IProductListFilter;
  }

  private getTableFilterOptionsQueryKey(): string {
    const params = this.buildProductListFilterOptionsParams();
    return params ? JSON.stringify(params) : '';
  }

  private shouldLoadTableFilterOptions(): boolean {
    return this.needLoadTableFilterOptions
      || this.lastTableFilterOptionsQueryKey !== this.getTableFilterOptionsQueryKey();
  }

  private loadTableFilterOptions() {
    const filter = this.buildProductListFilterOptionsParams();
    if (!filter) {
      this.groupFilterOptions = [];
      this.categoryFilterOptions = [];
      this.subcategoryFilterOptions = [];
      this.storeFormatFilterOptions = [];
      this.storeRegionFilterOptions = [];
      this.storeClusterFilterOptions = [];
      this.kht1FilterOptions = [];
      return;
    }

    const queryKey = this.getTableFilterOptionsQueryKey();
    this.needLoadTableFilterOptions = false;

    this.api.fetchProductListFilterOptions(filter)
      .then((resp) => {
        const data = resp.data;
        this.groupFilterOptions = this.toTagFilterOptions(data.groups || []);
        this.categoryFilterOptions = this.toTagFilterOptions(data.categories || []);
        this.subcategoryFilterOptions = this.toTagFilterOptions(data.subcategories || []);
        this.storeFormatFilterOptions = this.toTagFilterOptions(data.storeFormats || []);
        this.storeRegionFilterOptions = this.toTagFilterOptions(data.storeRegions || []);
        this.storeClusterFilterOptions = this.toTagFilterOptions(data.storeClusters || []);
        this.kht1FilterOptions = this.toTextFilterOptions(data.keyCharacteristicsOne || []);
        this.ensureStrategyTagsInFilterOptions();
        this.lastTableFilterOptionsQueryKey = queryKey;
      })
      .catch(() => {
        this.groupFilterOptions = [];
        this.categoryFilterOptions = [];
        this.subcategoryFilterOptions = [];
        this.storeFormatFilterOptions = [];
        this.storeRegionFilterOptions = [];
        this.storeClusterFilterOptions = [];
        this.kht1FilterOptions = [];
        this.lastTableFilterOptionsQueryKey = null;
      });
  }

  @Watch('selectedStrategies', { deep: true })
  private onSelectedStrategiesChanged() {
    this.syncTableFiltersFromStrategyContext();
    this.pagination.current = 1;
    this.needLoadTableFilterOptions = true;
    this.lastTableFilterOptionsQueryKey = null;
  }

  prepareAndFetchSkuList() {
    this.syncTableFiltersFromStrategyContext();
    this.pagination.current = 1;
    this.needLoadTableFilterOptions = true;
    this.lastTableFilterOptionsQueryKey = null;
    this.fetchSkuList();
  }

  @Watch('filters', { deep: true })
  private onProductListContextChanged() {
    if (!this.selectedStrategies.length) {
      this.resetTableColumnFilters();
      this.syncTableFiltersFromPageFilters();
      this.tableFilterSignature = this.buildTableFilterSignature();
    }
    this.needLoadTableFilterOptions = true;
    this.lastTableFilterOptionsQueryKey = null;
  }

  private fetchSkuList() {
    const filter = this.buildProductListFilterParams();
    if (!filter) {
      this.skuList = [];
      this.pagination.total = 0;
      return;
    }
    this.isPageTableLoading = true;
    const pageSize = this.pagination.pageSize || 10;
    const current = this.pagination.current || 1;
    const offset = (current - 1) * pageSize;
    this.api
      .fetchProductList(filter, { limit: pageSize, offset })
      .then((res) => {
        const content = res.data.content || [];
        const total = res.data.totalElements;
        this.pagination.total = total;
        this.skuList = content.map((row: any) => ({
          ...row,
          fixedGapType: row.fixedGapType,
          strategy: row.strategy,
          gap: row.gap,
          applyCompetitorPrices: row.applyCompetitorPrices,
          considerCompetitivePricing: row.applyCompetitorPrices,
          minProfitabilityLimit: row.minProfitabilityLimit,
        }));
      })
      .catch(() => {
        this.skuList = [];
        this.pagination.total = 0;
      })
      .finally(() => {
        this.isPageTableLoading = false;
        if (this.shouldLoadTableFilterOptions()) {
          this.loadTableFilterOptions();
        }
      });
  }

  private downloadProductList() {
    const params = this.buildProductListFilterParams();
    if (!params) return;
    this.isDownloadLoading = true;
    this.api
      .downloadProductListExcel(params)
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.$tc('omnichannelStrategy.messages.productsFilename'));
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {})
      .finally(() => {
        this.isDownloadLoading = false;
      });
  }

  private getErrorsAmount() {
    const id = this.tradingId;
    if (id == null) return;
    this.api.getLastFileErrorsAmount(id, 'OMNICHANNEL_INDIVIDUAL_FILTERS').then((r) => {
      this.errorsAmount = r.data;
    });
  }

  private downloadErrors() {
    const id = this.tradingId;
    if (id == null) {
      this.showError(this.$tc('omnichannelStrategy.messages.selectStrategy'));
      return;
    }

    this.api.getOmnichannelStrategiesIndividualImportErrors(id)
      .then((response) => {
        if (!response.data || (typeof response.data === 'string' && !response.data.trim())) {
          this.showInfo(this.$tc('omnichannelStrategy.messages.noErrors'));
          return;
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.$tc('omnichannelStrategy.messages.importErrorsFilename'));
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      });
  }

  private uploadWithFileForComponent(file: File): Promise<void> {
    const id = this.tradingId;
    if (id == null) {
      return Promise.reject(new Error(this.$tc('omnichannelStrategy.messages.selectStrategy')));
    }
    const uploadFile = new FormData();
    uploadFile.append('file', new Blob([file]), file.name);
    return this.api.uploadOmnichannelStrategiesIndividualFile(id, uploadFile).then(() => {});
  }

  private getUploadStatusForComponent(): Promise<{ status: string; progress?: number }> {
    const id = this.tradingId;
    if (id == null) {
      return Promise.reject(new Error(this.$tc('omnichannelStrategy.messages.noTradingCampaign')));
    }
    return this.api.getOmnichannelStrategiesIndividualUploadStatus(id).then((res) => ({
      status: res.data.status,
      progress: res.data.progress != null ? res.data.progress : undefined,
    }));
  }

  private fetchAllData() {
    this.fetchSkuList();
    this.getErrorsAmount();
  }
}
